import { z } from 'zod/v4';
import { SeverityDTO } from './severity';

/**
 * CI health summary for a time window.
 *
 * Field semantics (not expressible in types alone):
 * - Row is included if the CI had at least one interval in `severities`.
 *   There is no filter by worst_severity.
 * - "Not OK" = severity IN (3, 4, 5); independent of the severity filter.
 * - worst_severity ranks by domain order (NOT_CONF < N_A < OK < MAINTENANCE <
 *   WARNING < ERROR < CRITICAL), not numeric MAX (MAINTENANCE=6 > CRITICAL=5).
 * - current_severity null is valid (no active indicators at window end).
 * - his_by_severity is sparse: only keys "3"|"4"|"5", no zeros.
 * - time_not_ok_sec is merged intervals (not sum), clipped to the window.
 * - transitions_count can be 0 while time_not_ok_sec > 0.
 * - Counters respect allow_hit visibility and are user-specific.
 */
export const CISummaryDTO = z.object({
  ci_id: z.string(),
  ci_name: z.string().nullable(),
  ci_type_name: z.string().nullable(),

  current_severity: SeverityDTO.nullable(),
  current_status_since: z.string().nullable(),
  current_status_duration_sec: z.number().nullable(),
  his_total: z.number(),
  his_by_severity: z.record(z.string(), z.number()),

  worst_severity: SeverityDTO,
  time_not_ok_sec: z.number(),
  transitions_count: z.number(),
});

export type CISummary = z.infer<typeof CISummaryDTO>;

export const CISummaryPageDTO = z.object({
  items: z.array(CISummaryDTO),
  total: z.number(),
  page: z.number(),
  size: z.number(),
  allow_fields: z.array(z.string()),
  allow_tags: z.array(z.string()).optional(),
});